var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5776_114774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear_5776_114774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4701 12.5899C5.8701 11.8199 7.44009 11.1699 8.90009 10.5199C11.4201 9.45989 13.9401 8.40989 16.5001 7.43989C17.0001 7.26989 17.8901 7.10989 17.9801 7.84989C17.9301 8.88989 17.7401 9.92989 17.6001 10.9599C17.2601 13.2399 16.8601 15.5099 16.4701 17.7799C16.3401 18.5399 15.3901 18.9299 14.7801 18.4399C13.3201 17.4599 11.8601 16.4799 10.4201 15.4799C9.95009 14.9999 10.3901 14.3099 10.8101 13.9699C12.0101 12.7899 13.2801 11.7799 14.4201 10.5399C14.7301 9.79989 13.8201 10.4199 13.5201 10.6099C11.8801 11.7399 10.2801 12.9399 8.5401 13.9399C7.6601 14.4299 6.6201 14.0099 5.7401 13.7399C4.9501 13.4199 3.7901 13.0899 4.4701 12.5899Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5776_114774",
    x1: 15.516,
    y1: 3.7937,
    x2: 8.01601,
    y2: 21.2927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5776_114774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeleIcon);
export default __webpack_public_path__ + "static/media/tele_icon.86572a93b23f271a4ddd949b9980562e.svg";
export { ForwardRef as ReactComponent };